/**
 * Route areas the app does not carry at boot.
 *
 * Every route costs the entry chunk about 130 bytes gzip (its stub, its place in the route
 * tree and its lazy-chunk preload list) whether or not the visitor can ever open it. An area
 * listed here is left out of the tree the router is created with (`virtual:boot-route-tree`,
 * generated by `client/vite.router.ts`) and joins it the first time a visit needs it, when the
 * full tree (`routeTree.gen.ts`) loads as its own chunk. See `deferred-route-loader.ts` for the
 * loading side and `docs/plan/deferred-admin-route-tree/plan.md` for the measurements.
 *
 * An area is a directory directly under `client/src/routes` whose URL prefix has no
 * parameters. The generator ignores a directory by name at any depth, so that name must not
 * be reused further down the routes directory.
 *
 * `client/vite.router.ts` imports this module while vite loads its config, before any alias
 * exists. Keep it free of imports.
 */
export const DEFERRED_ROUTE_AREAS = [{ directory: '~admin-console', pathPrefix: '/admin-console' }] as const;

/** Whether `pathname` belongs to an area that is not in the boot route tree. */
export function isDeferredRoutePath(pathname: string): boolean {
    // The router matches paths case-insensitively, so this must too.
    const path = pathname.toLowerCase();
    return DEFERRED_ROUTE_AREAS.some(({ pathPrefix }) => path === pathPrefix || path.startsWith(`${pathPrefix}/`));
}
